import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
        path: "/",
        name: "首页",
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/about",
        name: "About",
        component: () => import("@/views/About.vue"),
      },
      {
        path: "/aboutUs",
        name: "了解我们",
        component: () => import("@/views/aboutUs/index.vue"),
      },
  {
    path: "/agreement",
    name: "注册协议",
    component: () => import("@/views/login/agreement.vue"),
  },
  {
    path: "/zhiboclass",
    name: "直播课",
    component: () => import("@/views/live/zhiboclass.vue"),
  },

  {
    path: "/zhiboclassxq",
    name: "直播课详情",
    component: () => import("@/views/live/zhiboclassxq.vue"),
  },
  {
    path: "/jingpin/courer",
    name: "精品课程",
    component: () => import("@/views/class/courer.vue"),
  }, 
  {
    path: "/publicClass",
    name: "公开课",
    component: () => import("@/views/publicClass/index.vue"),
  },
  {
    path: "/allcurriculum/typeclass",
    name: "课程分类",
    component: () => import("@/views/class/typeclass.vue"),
  },
   {
        path: "/seventhPage/myOperationDetails",
        name: "我的作业详情",
        component: () =>
          import("@/views/seventhPage/mine/learn/myOperationDetails.vue"),
      },
  {
    path: "/VIP/VIPClass",
    name: "VIP专属班",
    component: () => import("@/views/class/VIPclass.vue"),
  },
  {
    path: "/typeclassxq",
    name: "知识套餐课详情",
    component: () => import("@/views/class/typeclassxq.vue"),
  },
  {
    path: "/VIP/VIPClassxq",
    name: "VIP专属班详情",
    component: () => import("@/views/class/VIPclassxq.vue"),
  },
  {
    path: "/faculty",
    name: "师资力量",
    component: () => import("@/views/faculty/faculty.vue"),
  },
  {
    path: "/facultys",
    name: "学习工具",
    component: () => import("@/views/faculty/facultys.vue"),
  },
  {
    path: "/data/dataPackageDetail",
    name: "查看资料",
    component: () => import("@/views/data/dataPackageDetail.vue"),
  },
  {
    path: "/quesTion/examDetails",
    name: "做题",
    component: () => import("@/views/quesTion/examDetails.vue"),
  },
  {
    path: "/videoxq",
    name: "录播课详情",
    component: () => import("@/views/video/videoxq.vue"),
  },
  {
    path: "/data/dataPackage",
    name: "学习资料",
    component: () => import("@/views/data/dataPackage.vue"),
  },
  {
    path: "/data/materialPage",
    name: "资料列表",
    component: () => import("@/views/data/materialPage.vue"),
  },
  {
    path: "/quesTion/quesTionList",
    name: "题库",
    component: () => import("@/views/quesTion/quesTionList.vue"),
  },
  {
    path: "/all/examPack",
    name: "试卷包详情",
    component: () => import("@/views/quesTion/examPack.vue"),
  },
  {
    path: "/quesTion/examRoom/examRoomDetail",
    name: "虚拟考场",
    component: () => import("@/views/quesTion/examRoom/examRoomDetail.vue"),
  },
  {
    path: "/questionNew/questionAnswerOther",
    name: "做题",
    component: () => import("@/components/questionNew/questionAnswerOther.vue"),
  },
  {
    path: "/questionNew/questionAnswerAly",
    name: "做题",
    component: () => import("@/components/questionNew/questionAnswerAly.vue"),
  },
  
  {
    path: "/orders/classOrder",
    name: "知识套餐购买",
    component: () => import("@/views/order/classOrder.vue"),
  },
  {
    path: "/orders/classSure",
    name: "组合购买",
    component: () => import("@/views/order/classSure.vue"),
  },
  {
    path: "/orders/:orderNumber",
    name: "个人中心订单页",
    component: () => import("@/views/order/orders.vue"),
  },
  {
    path: "/livebofang",
    name: "直播课播放",
    component: () => import("@/views/live/livebofang.vue"),
  },
  {
    path: "/questionNew/questionAnswer",
    name: "做题",
    component: () => import("@/components/questionNew/questionAnswer.vue"),
  },
  {
    path: "/myView",
    name: "个人中心",
    component: () => import("@/views/mine/myView.vue"),
    children: [
      {
        path: "/my/myInfo",
        name: "个人资料",
        component: () => import("@/views/mine/my/myInfo.vue"),
      },
      {
        path: "/my/mineExchange",
        name: "我的兑换券",
        component: () => import("@/views/mine/my/mineExchange.vue"),
      },
      {
        path: "/my/feedback",
        name: "意见反馈",
        component: () => import("@/views/mine/my/feedback.vue"),
      },
      {
        path: "/my/accountSetting",
        name: "账户设置",
        component: () => import("@/views/mine/my/accountSetting.vue"),
      },
      {
        path: "/my/myCard",
        name: "学习卡",
        component: () => import("@/views/mine/my/myCard.vue"),
      },
      {
        path: "/my/collect",
        name: "我的收藏",
        component: () => import("@/views/mine/my/collect.vue"),
      },
      {
        path: "/my/mineNews",
        name: "消息通知",
        component: () => import("@/views/mine/my/mineNews.vue"),
      },
      {
        path: "/my/mineOrder",
        name: "我的订单",
        component: () => import("@/views/mine/my/mineOrder.vue"),
      },
      {
        path: "/my/mineCoupon",
        name: "我的优惠券",
        component: () => import("@/views/mine/my/mineCoupon.vue"),
      },
      {
        path: "/my/myAskQuestions",
        name: "我的提问",
        component: () => import("@/views/mine/my/myAskQuestions.vue"),
      },
    ],
  },
  {
    path: "/faculty/teacherDetail",
    name: "老师详情",
    component: () => import("@/views/faculty/teacherDetail.vue"),
  },
  {
    path: "/publicClass/publicClassDetail",
    name: "公开课详情",
    component: () => import("@/views/publicClass/publicClassDetail.vue"),
  },
  {
    path: "/dianbofang",
    name: "知识套餐录播课播放",
    component: () => import("@/views/video/dianbofang.vue"),
  },
  {
    path: "/all",
    name: "我的课程学习记录考试",
    component: () => import("@/views/mine/all.vue"),
    children: [
      {
        path: "/all/mycurriculum",
        name: "我的课程",
        component: () => import("@/views/mine/mycurriculum.vue"),
      },
      {
        path: "/all/practiceDailyDoQuestion",
        name: "每日一练",
        component: () => import("@/views/mine/practiceDailyDoQuestion.vue"),
      },
      {
        path: "/all/study",
        name: "学习记录",
        component: () => import("@/views/mine/study.vue"),
      },
      {
        path: "/all/practiceDaily",
        name: "每日一练",
        component: () => import("@/views/mine/practiceDaily.vue"),
      },
      {
        path: "/all/myOperation",
        name: "我的作业",
        component: () => import("@/views/mine/myOperation.vue"),
      },
      {
        path: "/all/myRoom",
        name: "我的考场",
        component: () => import("@/views/mine/myRoom.vue"),
      },
      {
        path: "/all/myexamination",
        name: "我的题库",
        component: () => import("@/views/mine/myexamination.vue"),
      },
      {
        path: "/all/mydata",
        name: "我的资料",
        component: () => import("@/views/data/mineData.vue"),
      },
      {
        path: "/all/curriculumName",
        name: "学习中心课程名",
        component: () => import("@/views/mine/curriculumName.vue"),
      },
      {
        path: "/all/courseLearningRate",
        name: "学习中心课程详情",
        component: () => import("@/views/mine/courseLearningRate.vue"),
      },
      {
        path: "/all/collect",
        name: "收藏夹",
        component: () => import("@/views/mine/collect.vue"),
      },
      {
        path: "/all/correctionNotebook",
        name: "错题本",
        component: () => import("@/views/mine/correctionNotebook.vue"),
      },
      {
        path: "/all/doQuestionRecord",
        name: "做题记录",
        component: () => import("@/views/mine/doQuestionRecord.vue"),
      },
      {
        path: "/all/fallible",
        name: "易错题",
        component: () => import("@/views/mine/fallible.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// 监听路由变化，页面返回顶部并设置标题
router.afterEach((to) => {
  window.scrollTo(0, 0);
  // 设置页面标题为路由的name值
  if (to.name) {
    document.title = to.name;
  }
});

export default router;
